// tabs/MeasuresTab.jsx - Measures tab
import React, { useState } from 'react';
import { Box, Grid, Stack, TextInput, Group, Text, NumberInput, Paper } from '@mantine/core';

const MeasuresTab = ({ selectedLineId }) => {
  const [measuresData, setMeasuresData] = useState({
    unitMeasures: {
      weight: 2.000,
      weightUnit: 'LB',
      length: 10.000,
      lengthUnit: 'IN',
      volume: 0.000,
      volumeUnit: 'CIN'
    },
    lineTotals: {
      weight: 0.000,
      length: 0.000,
      volume: 0.000
    },
    convertedLineTotals: {
      weight: 0.000,
      length: 0.000,
      volume: 0.000
    },
    qtyUM: 'EA',
    qtyValue: 1.000000,
    priceUM: 'EA',
    priceValue: 1.000000,
    lineQty: 0,
    lineQtyUM: 'EA'
  });

  const handleUnitMeasureChange = (field, value) => {
    setMeasuresData(prev => ({
      ...prev,
      unitMeasures: { ...prev.unitMeasures, [field]: value }
    }));
  };

  const handleLineTotalChange = (field, value) => {
    setMeasuresData(prev => ({
      ...prev,
      lineTotals: { ...prev.lineTotals, [field]: value }
    }));
  };

  const handleConvertedTotalChange = (field, value) => {
    setMeasuresData(prev => ({
      ...prev,
      convertedLineTotals: { ...prev.convertedLineTotals, [field]: value }
    }));
  };

  const handleChange = (field, value) => {
    setMeasuresData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Box p="md">
      <Grid gutter="md">
        {/* Left Column - Unit Measures Info per [EA] */}
        <Grid.Col span={6}>
          <Paper withBorder p="sm">
            <Text size="sm" fw={500} mb="sm">Unit Measures Info per [EA]</Text>
            <Stack spacing="xs">
              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={60}>Weight:</Text>
                <NumberInput
                  value={measuresData.unitMeasures.weight}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={3}
                  fixedDecimalScale
                  onChange={(value) => handleUnitMeasureChange('weight', value)}
                />
                <TextInput
                  value={measuresData.unitMeasures.weightUnit}
                  variant="filled"
                  size="sm"
                  w={50}
                  styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                  onChange={(e) => handleUnitMeasureChange('weightUnit', e.target.value)}
                />
                <Box style={{ width: '80px' }}>
                  <Text size="sm" fw={500} ta="center">Line Totals</Text>
                </Box>
                <NumberInput
                  value={measuresData.lineTotals.weight}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={3}
                  fixedDecimalScale
                  onChange={(value) => handleLineTotalChange('weight', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={60}>Length:</Text>
                <NumberInput
                  value={measuresData.unitMeasures.length}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={3}
                  fixedDecimalScale
                  onChange={(value) => handleUnitMeasureChange('length', value)}
                />
                <TextInput
                  value={measuresData.unitMeasures.lengthUnit}
                  variant="filled"
                  size="sm"
                  w={50}
                  styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                  onChange={(e) => handleUnitMeasureChange('lengthUnit', e.target.value)}
                />
                <Box style={{ width: '80px' }} />
                <NumberInput
                  value={measuresData.lineTotals.length}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={3}
                  fixedDecimalScale
                  onChange={(value) => handleLineTotalChange('length', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={60}>Volume:</Text>
                <NumberInput
                  value={measuresData.unitMeasures.volume}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={3}
                  fixedDecimalScale
                  onChange={(value) => handleUnitMeasureChange('volume', value)}
                />
                <TextInput
                  value={measuresData.unitMeasures.volumeUnit}
                  variant="filled"
                  size="sm"
                  w={50}
                  styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                  onChange={(e) => handleUnitMeasureChange('volumeUnit', e.target.value)}
                />
                <Box style={{ width: '80px' }} />
                <NumberInput
                  value={measuresData.lineTotals.volume}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={3}
                  fixedDecimalScale
                  onChange={(value) => handleLineTotalChange('volume', value)}
                />
              </Group>
            </Stack>
          </Paper>
        </Grid.Col>

        {/* Right Column - Converted Line Totals */}
        <Grid.Col span={6}>
          <Paper withBorder p="sm">
            <Text size="sm" fw={500} mb="sm">Converted Line Totals</Text>
            <Stack spacing="xs">
              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={60}>Weight:</Text>
                <NumberInput
                  value={measuresData.convertedLineTotals.weight}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={3}
                  fixedDecimalScale
                  onChange={(value) => handleConvertedTotalChange('weight', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={60}>Length:</Text>
                <NumberInput
                  value={measuresData.convertedLineTotals.length}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={3}
                  fixedDecimalScale
                  onChange={(value) => handleConvertedTotalChange('length', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={60}>Volume:</Text>
                <NumberInput
                  value={measuresData.convertedLineTotals.volume}
                  variant="filled"
                  size="sm"
                  w={80}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={3}
                  fixedDecimalScale
                  onChange={(value) => handleConvertedTotalChange('volume', value)}
                />
              </Group>
            </Stack>
          </Paper>
        </Grid.Col>

        {/* Bottom Row - Quantity and Price UM */}
        <Grid.Col span={12}>
          <Group spacing="lg" mt="md">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500}>Qty UM:</Text>
              <TextInput
                value={measuresData.qtyUM}
                variant="filled"
                size="sm"
                w={50}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleChange('qtyUM', e.target.value)}
              />
              <Text size="sm" fw={500}>/</Text>
              <NumberInput
                value={measuresData.qtyValue}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={6}
                fixedDecimalScale
                onChange={(value) => handleChange('qtyValue', value)}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500}>Price UM:</Text>
              <TextInput
                value={measuresData.priceUM}
                variant="filled"
                size="sm"
                w={50}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleChange('priceUM', e.target.value)}
              />
              <Text size="sm" fw={500}>/</Text>
              <NumberInput
                value={measuresData.priceValue}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={6}
                fixedDecimalScale
                onChange={(value) => handleChange('priceValue', value)}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500}>Line Qty:</Text>
              <NumberInput
                value={measuresData.lineQty}
                variant="filled"
                size="sm"
                w={60}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                onChange={(value) => handleChange('lineQty', value)}
              />
              <Text size="sm" fw={500}>/</Text>
              <TextInput
                value={measuresData.lineQtyUM}
                variant="filled"
                size="sm"
                w={50}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleChange('lineQtyUM', e.target.value)}
              />
            </Group>
          </Group>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default MeasuresTab;